import { IAction, IAppStatus } from "@/common/interface";
import { SET_APP_STATUS } from "../../actionTypes";

const initState: IAppStatus = {};

export default (state = initState, action: IAction): IAppStatus => {
  switch (action.type) {
    case SET_APP_STATUS:
      return { ...state, ...action.data };
    default:
      return state;
  }
};
